export const ROUTES = {
  HOME: '/',
  PROFILE: '/profile',
  BRANDS: '/brands',
  BRANDS_CREATE: '/brands/create',
  BRANDS_EDIT: '/brands/:brandId/edit',
  BRAND_PRODUCTS: '/brands/:brandId/products',
  BRAND_PRODUCTS_CREATE: '/brands/:brandId/products/create',
  BRAND_PRODUCT_CONFIGS: '/brands/:brandId/products/:productId/configs',
  BRAND_PRODUCT_CONFIGS_CREATE: '/brands/:brandId/products/:productId/configs/create',
  BRAND_PRODUCT_CONFIGS_VIEW: '/brands/:brandId/products/:productId/configs/:configId',
  UPLOAD: '/upload/:uploadType',
};
